export default __webpack_public_path__ + "static/media/biote_pan.6f3de5b2.png";